import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { SWRConfig } from "swr";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { fetcher } from "@/lib/api";
import LoginPage from "@/pages/LoginPage";
import DisclaimerGate from "@/pages/DisclaimerGate";
import AppShell from "@/components/layout/AppShell";
import Overview from "@/pages/Overview";
import Property from "@/pages/Property";
import Financials from "@/pages/Financials";
import Comps from "@/pages/Comps";
import Documents from "@/pages/Documents";
import Benchmarks from "@/pages/Benchmarks";
import Admin from "@/pages/Admin";

function Splash() {
  return (
    <div className="min-h-screen iron-pattern flex items-center justify-center" data-testid="app-loading">
      <div className="h-10 w-10 rounded-full border-2 border-[#C59B27]/30 border-t-[#C59B27] animate-spin" />
    </div>
  );
}

function Gate() {
  const { status, ack, role } = useAuth();
  if (status === "loading") return <Splash />;
  if (status === "anon") return <LoginPage />;
  if (!ack) return <DisclaimerGate />;
  return (
    <SWRConfig key={role} value={{ fetcher, provider: () => new Map(), revalidateOnFocus: false }}>
      <Routes>
        <Route element={<AppShell />}>
          <Route path="/overview" element={<Overview />} />
          <Route path="/property" element={<Property />} />
          <Route path="/financials" element={<Financials />} />
          <Route path="/comps" element={<Comps />} />
          <Route path="/benchmarks" element={<Benchmarks />} />
          <Route path="/documents" element={<Documents />} />
          <Route path="/admin" element={role === "admin" ? <Admin /> : <Navigate to="/overview" replace />} />
          <Route path="*" element={<Navigate to="/overview" replace />} />
        </Route>
      </Routes>
    </SWRConfig>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Gate />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
